var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('b-form-radio-group',{on:{"input":_vm.onSelection}},[_c('b-form-radio',{attrs:{"value":_vm.yesValue}},[_vm._v(_vm._s(_vm.yesLabel))]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":_vm.noValue}},[_vm._v(_vm._s(_vm.noLabel))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }